import React from "react";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { Link, useNavigation } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import Loader from "../Shared/Loader/Loader";
import { MdStar } from "react-icons/md";
import { AiFillDelete } from "react-icons/ai";
import { MdEditSquare } from "react-icons/md";
import "./MyReviewCard.css";

const MyReviewCard = ({ myReview, refresh, setRefresh }) => {
  const { _id, serviceId, serviceName, message, ratings, serviceImg } =
    myReview;

  const navigation = useNavigation();

  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleClickDelete = (id) => {
    setDeleteId(id);
    setShow(true);
  };

  const handleDeleteItem = () => {
    console.log("deleting:", _id);

    setLoading(true);
    fetch(`https://food-for-you-server.vercel.app/reviews/${_id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.deletedCount > 0) {
          toast.success("Review deleted successfully");
          setLoading(false);
          setRefresh(!refresh);
        }
      });

    setShow(false);
  };

  if (navigation.state === "loading") {
    return <Loader />;
  }

  return (
    <section data-aos="fade-left" data-aos-duration="2000">
      <div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Are you sure to Delete?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Deleting this review for
            <span className="fw-semibold ms-1">{serviceName}</span> cannot be
            undone!
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger bg-gradient" onClick={handleDeleteItem}>
              Delete
            </Button>
            <Button variant="primary bg-gradient" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className="col">
        <div className="card card-log rounded-4 review-card mx-auto shadow border-to border-0 d-flex justify-content-between flex-column-reverse align-items-center flex-md-row gap-5">
          <div className="rounded-3 myreview-container mx-auto d-flex flex-column justify-content-center mb-2">
            <div className="mt-review-card">
              <div className="card-body">
                <Link to={`/services/${serviceId}`} className="service-id-link">
                  <h5
                    className="card-title text-success mb-4 fw-bold service-id-link"
                    title="Click to go the details page"
                  >
                    {serviceName}
                  </h5>
                </Link>
                <p className="card-title">
                  <b>Review:</b> <span className="ms-1">{message}</span>
                </p>
                <p className="card-title">
                  <b>Rating:</b>
                  <span className="fw-semibold text-primary ms-2">
                    {ratings}
                  </span>
                  <span>
                    <MdStar className="orange-color fs-my-5 mb-1" />
                  </span>
                </p>
              </div>
            </div>

            <div className="d-flex ms-3">
              <div>
                <Link to={`/update-my-review/${_id}`}>
                  <button className="btn btn-sm btn-outline-primary bg-gradient me-3 p-btn">
                    <div className="d-flex justify-content-center align-items-center">
                      <span>
                        <MdEditSquare size={18} />
                      </span>
                      <span className="ms-1 m-cus">Update</span>
                    </div>
                  </button>
                </Link>
              </div>

              <div>
                <Link>
                  <button
                    className="btn btn-sm btn-outline-danger bg-gradient p-btn"
                    // onClick={() => handleDelete(_id)}
                    onClick={() => handleClickDelete(_id)}
                  >
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center py-1">
                        <ScaleLoader
                          color="red"
                          height="13"
                          speedMultiplier=".6"
                        />
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center">
                        <span>
                          <AiFillDelete size={18} />
                        </span>
                        <span className="ms-1 m-cus">Delete</span>
                      </div>
                    )}
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div className="review-serviceImg-container d-flex align-items-center justify-content-center">
            <PhotoProvider
              speed={() => 800}
              easing={(type) =>
                type === 2
                  ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                  : "cubic-bezier(0.34, 1.56, 0.64, 1)"
              }
            >
              <PhotoView src={serviceImg}>
                <figure>
                  <LazyLoadImage
                    src={serviceImg}
                    alt={serviceName}
                    className="review-serviceImg card-log shadow-sm"
                    placeholderSrc={serviceImg}
                    effect="blur"
                    title={serviceName}
                    style={{ objectFit: "cover", cursor: "pointer" }}
                  />
                </figure>
              </PhotoView>
            </PhotoProvider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyReviewCard;
